import { useExportContext } from 'lib/context/ExportContext/ExportContext';

import Button from 'components/shared/Buttons/Button';

const InvoiceModalHeader = () => {
  const { onPrint } = useExportContext();

  return (
    <div className="flex w-full justify-between">
      <h6 className="text-primary-900">Create Invoice</h6>
      <Button
        color="primary-900"
        size="small"
        type="link"
        text="Print"
        icon="printer-mono"
        className="text-primary-900"
        onClick={onPrint}
      />
    </div>
  );
};

export default InvoiceModalHeader;
